module.exports = __webpack_public_path__ + "assets/videos/intro/intro-3d-new-desktop/0046.jpg?v=45cf3c33";